import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SelectivePreloadingStrategy } from './selective-preload-strategy';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: () => import('./Pages/feed/feed.module').then( m => m.FeedPageModule),
    data: { preload: true }
  },
  {
    path: 'world-map',
    loadChildren: () => import('./Pages/home/home.module').then( m => m.HomePageModule),
    data: { preload: true }
  },
  {
    path: 'login',
    loadChildren: () => import('./Pages/login/login.module').then( m => m.LoginPageModule),
    data: { preload: true }
  },
  {
    path: 'login/:impersonateUserToken',
    loadChildren: () => import('./Pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'signup',
    loadChildren: () => import('./Pages/User-Account/signup/signup.module').then( m => m.SignupPageModule)
  },
  {
    path: 'user-location',
    loadChildren: () => import('./Pages/user-location/user-location.module').then( m => m.UserLocationPageModule)
  },
  {
    path: 'my-duckings',
    loadChildren: () => import('./Pages/my-duckings/my-duckings.module').then( m => m.MyDuckingsPageModule),
    data: { preload: true }
  },
  {
    path: 'leader-boards',
    loadChildren: () => import('./Pages/leader-boards/leader-boards.module').then( m => m.LeaderBoardsPageModule)
  },
  {
    path: 'settings',
    loadChildren: () => import('./Pages/my-account/my-account.module').then( m => m.MyAccountPageModule)
  },
  {
    path: 'my-duckings/got-ducked-details',
    loadChildren: () => import('./Pages/got-ducked-details/got-ducked-details.module').then( m => m.GotDuckedDetailsPageModule)
  },
  {
    path: 'my-duckings/ducked-someone-details',
    loadChildren: () => import('./Pages/ducked-someone-details/ducked-someone-details.module').then( m => m.DuckedSomeoneDetailsPageModule)
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./Pages/User-Account/forgot-password/forgot-password.module').then( m => m.ForgotPasswordPageModule)
  },
  {
    path: 'reset-password/:token',
    loadChildren: () => import('./Pages/User-Account/reset-password/reset-password.module').then( m => m.ResetPasswordPageModule)
  },
  {
    path: 'change-password',
    loadChildren: () => import('./Pages/User-Account/change-password/change-password.module').then( m => m.ChangePasswordPageModule)
  },
  {
    path: 'message-list',
    loadChildren: () => import('./Pages/Messages/message-list/message-list.module').then( m => m.MessageListPageModule),
    data: { preload: true }
  },
  {
    path: 'messages',
    loadChildren: () => import('./Pages/Messages/message-details/message-details.module').then( m => m.MessageDetailsPageModule)
  },
  {
    path: 'messages/:handle',
    loadChildren: () => import('./Pages/Messages/message-details/message-details.module').then( m => m.MessageDetailsPageModule)
  },
  {
    path: 'products-list',
    loadChildren: () => import('./Pages/Shopping/list-products/list-products.module').then( m => m.ListProductsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'product-details/:productId',
    loadChildren: () => import('./Pages/Shopping/view-products/view-products.module').then( m => m.ViewProductsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'duckings/ducks-by-handle/:handle',
    loadChildren: () => import('./Pages/list-ducks-by-handle/list-ducks-by-handle.module').then( m => m.ListDucksByHandlePageModule)
  },
  {
    path: 'social-sharing/:id',
    loadChildren: () => import('./Pages/social-sharing/social-sharing.module').then( m => m.SocialSharingPageModule)
  },
  {
    path: 'support',
    loadChildren: () => import('./Pages/help/help.module').then( m => m.HelpPageModule)
  },
  {
    path: 'feed',
    loadChildren: () => import('./Pages/feed/feed.module').then( m => m.FeedPageModule),
    data: { preload: true }
  },
  {
    path: 'my-account',
    loadChildren: () => import('./Pages/user-profile/user-profile.module').then( m => m.UserProfilePageModule)
  },
  {
    path: 'user-profile',
    loadChildren: () => import('./Pages/user-profile/user-profile.module').then( m => m.UserProfilePageModule)
  },
  {
    path: 'user-profile/:handle',
    loadChildren: () => import('./Pages/user-profile/user-profile.module').then( m => m.UserProfilePageModule)
  },
  {
    path: 'admin',
    loadChildren: () => import('./Pages/admin/admin.module').then( m => m.AdminPageModule)
  },
  {
    path: 'broadcast-message',
    loadChildren: () => import('./Pages/admin/broadcast-message/broadcast-message.module').then( m => m.BroadcastMessagePageModule)
  },
  {
    path: 'system-stats',
    loadChildren: () => import('./pages/system-stats/system-stats.module').then( m => m.SystemStatsPageModule)
  },
  {
    path: 'user-management',
    loadChildren: () => import('./pages/user-management/user-management.module').then( m => m.UserManagementPageModule)
  },
  {
    path: 'content-management',
    loadChildren: () => import('./pages/content-management/content-management.module').then( m => m.ContentManagementPageModule)
  },
  {
    path: 'ducking-management',
    loadChildren: () => import('./pages/ducking-management/ducking-management.module').then( m => m.DuckingManagementPageModule)
  },
  {
    path: 'reported-content',
    loadChildren: () => import('./pages/reported-content/reported-content.module').then( m => m.ReportedContentPageModule)
  },
  {
    path: 'feed-management',
    loadChildren: () => import('./pages/feed-management/feed-management.module').then( m => m.FeedManagementPageModule)
  },
  {
    path: 'content-filters',
    loadChildren: () => import('./pages/content-filters/content-filters.module').then( m => m.ContentFiltersPageModule)
  },
  {
    path: 'auto-moderation',
    loadChildren: () => import('./pages/auto-moderation/auto-moderation.module').then( m => m.AutoModerationPageModule)
  },
  {
    path: 'announcement-banners',
    loadChildren: () => import('./pages/announcement-banners/announcement-banners.module').then( m => m.AnnouncementBannersPageModule)
  },
  {
    path: 'product-management',
    loadChildren: () => import('./pages/product-management/product-management.module').then( m => m.ProductManagementPageModule)
  },
  {
    path: 'product-catalog',
    loadChildren: () => import('./pages/product-catalog/product-catalog.module').then( m => m.ProductCatalogPageModule)
  },
  {
    path: 'product-variants',
    loadChildren: () => import('./pages/product-variants/product-variants.module').then( m => m.ProductVariantsPageModule)
  },
  {
    path: 'inventory-management',
    loadChildren: () => import('./pages/inventory-management/inventory-management.module').then( m => m.InventoryManagementPageModule)
  },
  {
    path: 'order-management',
    loadChildren: () => import('./pages/order-management/order-management.module').then( m => m.OrderManagementPageModule)
  },
  {
    path: 'shopping-cart',
    loadChildren: () => import('./Pages/Shopping/shopping-cart/shopping-cart.module').then( m => m.ShoppingCartPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'order-success',
    loadChildren: () => import('./Pages/Shopping/order-success/order-success.module').then( m => m.OrderSuccessPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'order-history',
    loadChildren: () => import('./Pages/Shopping/order-history/order-history.module').then( m => m.OrderHistoryPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'product-detail',
    loadChildren: () => import('./Pages/Shopping/product-detail/product-detail.module').then( m => m.ProductDetailPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'order-detail/:id',
    loadChildren: () => import('./Pages/Shopping/order-detail/order-detail.module').then( m => m.OrderDetailPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'admin/order-detail/:id',
    loadChildren: () => import('./Pages/order-detail/order-detail.module').then( m => m.OrderDetailPageModule)
  },
  {
    path: 'product-edit',
    loadChildren: () => import('./Pages/product-edit/product-edit.module').then( m => m.ProductEditPageModule)
  },
  {
    path: 'discounts-coupons',
    loadChildren: () => import('./Pages/discounts-coupons/discounts-coupons.module').then( m => m.DiscountsCouponsPageModule)
  },
  {
    path: 'cart-recovery',
    loadChildren: () => import('./Pages/cart-recovery/cart-recovery.module').then( m => m.CartRecoveryPageModule)
  },
  {
    path: 'active-sessions',
    loadChildren: () => import('./Pages/User-Account/active-sessions/active-sessions.module').then( m => m.ActiveSessionsPageModule)
  }




 











];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: SelectivePreloadingStrategy })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
